export default __webpack_public_path__ + "static/media/cert5.b8ac2531.jpg";